"use client";

import useModalStore from "@/tools/stores/modal";
import { CampaignProvider } from "@/tools/analytics";
import modalRegistry from "./registry";

const ModalRoot = () => {
  const activeModal = useModalStore((state) => state.activeModal);
  // ModalRoot is mounted in `Layout` beside `<main>`, so everything it renders
  // sits outside the page template's `<CampaignProvider>` and would read a null
  // campaign. The section that opened the modal captured the page's value while
  // it still had context; re-providing it here restores the normal precedence
  // (URL `?campaign_id=` ▶ page campaign) for every cart action and donate
  // widget inside the modal, rather than each one taking a campaign prop.
  const campaignId = useModalStore((state) => state.payload?.campaignId ?? null);

  if (!activeModal) {
    return null;
  }

  const ModalComponent = modalRegistry[activeModal];
  if (!ModalComponent) {
    return null;
  }

  return (
    <CampaignProvider campaignId={campaignId}>
      <ModalComponent />
    </CampaignProvider>
  );
};

export default ModalRoot;
